import {AddrDetailApiResponse} from '@dms/api/core';

import {ApiEnumItem} from '../../../types/ApiEnum';
import {AuctionTypeFilter} from './AuctionTypeFilter';
import {CarStatusFilter} from './CarStatusFilter';

export type FiltersType = {
  address?: AddrDetailApiResponse | null;
  radius?: number | null;
  sellerCountry?: string[];
  sellerServer?: string[];
  sellerType?: string[];
  make?: string[];
  model?: string[];
  fuelType?: string[];
  transmission?: string[];
  bodyType?: string[];
  doorCount?: string[];
  drive?: string[];
  selectedColors?: ApiEnumItem[];
  reclaimableVat?: boolean;
  hideSuspicious: boolean;
  hitlistOnly?: boolean;
  hideBlacklist?: boolean;
  features?: string[];
  adTitle?: string | null;
  trimLevels?: string[];

  // sliders
  mileageRange?: [number, number];
  power?: [number, number];
  cubicCapacity?: [number, number];
  margin?: [number, number];
  marginPercent?: [number, number];
  priceCZK?: [number, number];
  liquidity?: [number, number];
  pricePosition?: [number, number];
  daysOnDisplay?: [number, number];
  year?: [number, number];
  numberOfSeats?: [number, number];
  avgNumberAds?: [number, number];
  featureScore?: [number, number];

  // helpers
  isMarginAbsolute: boolean;
  isPowerInKW: boolean;

  // auction-specific filters
  auctionType?: AuctionTypeFilter[];
  carStatus?: CarStatusFilter[];
  auctionServer?: string[];
};

export const DEFAULT_FILTERS: FiltersType = {
  isMarginAbsolute: true,
  isPowerInKW: true,
  hideSuspicious: false,
};
